import {useState} from 'react';
import dynamic from 'next/dynamic';
import {useFormContext} from 'react-hook-form';
import {Grid, Typography} from '@mui/material';
import {RHFMultilingualField} from '@/shared/components/forms/theme-elements/form/RHFMultilingualField';
import {RHFTextField} from '@/shared/components/forms/theme-elements/form/RHFTextField';
const FileUploader = dynamic(
  () =>
    import('@/shared/components/forms/theme-elements/form/fileUploader').then(
      (mod) => mod.FileUploader
    ),
  {ssr: false}
);

export const Videos = () => {
  const [fileLoading, setFileLoading] = useState(false);

  const {
    watch,
    formState: {errors},
    control,
    setValue,
  } = useFormContext();

  const values = watch('menus.navigations.videos');

  return (
    <Grid>
      <Typography variant='h6' mb={2}>
        Label
      </Typography>

      <RHFMultilingualField name={'menus.navigations.videos.label'} />

      <Typography variant='h6' mb={2}>
        Title
      </Typography>

      <RHFMultilingualField name={'menus.navigations.videos.title'} />

      <Typography variant='h6' mb={2}>
        URL
      </Typography>

      <RHFTextField
        label={'URL'}
        control={control}
        name={'menus.navigations.videos.video.url'}
        error={errors?.menus?.navigations?.videos?.video?.url}
      />

      <Typography variant='h6' mb={2}>
        Thumbnail
      </Typography>

      <Grid sx={{width: '50%'}}>
        <FileUploader
          meta={{shape: 'Rectangle', size: {width: 1000, height: 600}}}
          name={'menus.navigations.videos.video.thumbnail'}
          setFileUrl={(links) =>
            setValue(`menus.navigations.videos.video.thumbnail`, links[0])
          }
          destination={'landing-pages'}
          values={values?.video?.thumbnail}
          setFileLoading={setFileLoading}
          setValue={setValue}
        />
      </Grid>
    </Grid>
  );
};
